import UserService from './user.service'
import StoreService from './store.service'
import helper from '../helper'

class PaperService {
  
  static _store = null
  static _papers = []

  static NAME = process.env.VUE_APP_NAME
  static HOST = process.env.VUE_APP_HOST
  
  static isOwner(paper) {
    const email = _.get(UserService.user(), "email", "xyz")
    return _.get(paper, "email", "abcd") === email
  }

  static isShow(paper) {
    const isPublished = _.get(paper, "published", false) === true;
    const isOwner = this.isOwner(paper);
    const isAdmin = UserService.isAdmin();
    //console.log(paper.title, "isPublished", isPublished, "isOwner", isOwner, "isAdmin", isAdmin)
    return isPublished || isOwner || isAdmin
  }

  static canEdit(paper) {
    return this.isOwner(paper) || UserService.isAdmin()
  }

  static store() {
    if (_.isNil(this._store)) this._store = StoreService.store("paper")
    return this._store
  }

  static getPapers() {
    return this._papers;
  }

  static fetch() {
    //console.log("papers fetch")
    return this.store().all(this._papers.length)
      .then(papers => {
        helper.push(this._papers, papers);
        return papers;
      });
  }
  
  static getShareLink(paper) {
    const hash = _.kebabCase(paper.title + " " + _.split(paper.created, " ")[0])
    return this.HOST + window.location.pathname + "?u=news/" + hash    
  }
  
  static getShareTitle(paper) {
    return _.capitalize(_.toLower(paper.title))
  }

}

export default PaperService

export {PaperService}